export const SENSITIVE_FIELDS = [
  'password',
  'accessToken',
  'refreshToken',
  'token',
  'ssn',
  'ein',
  'itin',
  'tin',
  'fein',
  'taxId',
  'accountNumber',
  'routingNumber',
  'cardNumber',
  'cvv',
  'driverLicenseNumber',
]

export function sanitizeObject<T>(obj: T): T {
  if (!obj || typeof obj !== 'object') {
    return obj
  }

  const result: Record<string, unknown> = {}
  for (const [key, value] of Object.entries(obj)) {
    if (SENSITIVE_FIELDS.some((field) => key.toLowerCase().includes(field.toLowerCase()))) {
      result[key] = '[REDACTED]'
    } else if (typeof value === 'object' && value !== null) {
      result[key] = sanitizeObject(value)
    } else {
      result[key] = value
    }
  }

  return result as T
}
